export default "__VITE_ASSET__0uiEKyj3__"